var _path, _path2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 19,
    viewBox: "0 0 15 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 19H0V0H15V19Z",
    stroke: "#E5E7EB"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_142_3718",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 15,
    height: 19
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.71875 0.25H14.2188V18.25H0.71875V0.25Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_142_3718)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.21094 0.32773C1.50977 0.190621 1.86133 0.239839 2.11094 0.454293L3.53125 1.6707L4.95156 0.454293C5.26797 0.183589 5.73555 0.183589 6.04844 0.454293L7.46875 1.6707L8.88906 0.454293C9.20547 0.183589 9.67305 0.183589 9.98594 0.454293L11.4062 1.6707L12.8266 0.454293C13.0762 0.239839 13.4277 0.190621 13.7266 0.32773C14.0254 0.464839 14.2188 0.763668 14.2188 1.09414V17.4067C14.2188 17.7371 14.0254 18.036 13.7266 18.1731C13.4277 18.3102 13.0762 18.261 12.8266 18.0465L11.4062 16.8301L9.98594 18.0465C9.66953 18.3172 9.20195 18.3172 8.88906 18.0465L7.46875 16.8301L6.04844 18.0465C5.73203 18.3172 5.26445 18.3172 4.95156 18.0465L3.53125 16.8301L2.11094 18.0465C1.86133 18.261 1.50977 18.3102 1.21094 18.1731C0.912109 18.036 0.71875 17.7371 0.71875 17.4067V1.09414C0.71875 0.763668 0.912109 0.464839 1.21094 0.32773ZM4.09375 5.31289C3.78437 5.31289 3.53125 5.56602 3.53125 5.87539C3.53125 6.18477 3.78437 6.43789 4.09375 6.43789H10.8438C11.1531 6.43789 11.4062 6.18477 11.4062 5.87539C11.4062 5.56602 11.1531 5.31289 10.8438 5.31289H4.09375ZM3.53125 12.6254C3.53125 12.9348 3.78437 13.1879 4.09375 13.1879H10.8438C11.1531 13.1879 11.4062 12.9348 11.4062 12.6254C11.4062 12.316 11.1531 12.0629 10.8438 12.0629H4.09375C3.78437 12.0629 3.53125 12.316 3.53125 12.6254ZM4.09375 8.68789C3.78437 8.68789 3.53125 8.94102 3.53125 9.25039C3.53125 9.55976 3.78437 9.81289 4.09375 9.81289H10.8438C11.1531 9.81289 11.4062 9.55976 11.4062 9.25039C11.4062 8.94102 11.1531 8.68789 10.8438 8.68789H4.09375Z",
    fill: "#9CA3AF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrder);
export default __webpack_public_path__ + "static/media/order.1cde350ee2ade221e1d15e5b8ad5b42e.svg";
export { ForwardRef as ReactComponent };